<script>
import i18n from "@/i18n";
import BaseTab from "@/components/BaseTab.vue";
import OrgProfileNewsList from "@/views/profile/OrgProfile/OrgProfileNewsList.vue";
import OrgProfileOpinionsList from "@/views/profile/OrgProfile/OrgProfileOpinionsList.vue";
import OrgProfileProposalsList from "@/views/profile/OrgProfile/OrgProfileProposalsList.vue";
import ProfileCriticalEvents from "@/views/profile/ProfileCriticalEvents.vue";
import {CreatorType} from "@/store/model/ImgLabel";
import OrgProfileManageAdmins from "@/views/profile/OrgProfile/OrgProfileManageAdmins.vue";

export default {
  name: "OrgProfileContentInfo",
  components: {
    OrgProfileManageAdmins,
    ProfileCriticalEvents,
    BaseTab,
    OrgProfileNewsList,
    OrgProfileOpinionsList,
    OrgProfileProposalsList
  },
  props: {
    orgId: {
      type: Number
    },
    isOwnProfile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeTab: {},
    }
  },
  computed: {
    CreatorType() {
      return CreatorType
    },
    tabs() {
      const tabs = [];
      if (this.isOwnProfile) {
        tabs.push(
            {
              label: i18n.global.t('profile.tabs.criticalEvents'),
              code: 'EVENTS',
            }
        );
      }
      tabs.push(
        {
          label: i18n.global.t('profile.tabs.news'),
          code: 'NEWS',
        },
        {
          label: i18n.global.t('profile.tabs.opinions'),
          code: 'OPINIONS',
        },
        {
          label: i18n.global.t('profile.tabs.proposals'),
          code: 'PROPOSALS',
        }
      );
      if (this.isOwnProfile) {
        tabs.push(
            {
              label: i18n.global.t('profile.tabs.manageAdministrators'),
              code: 'ADMINS',
            }
        );
      }
      return tabs;
    }
  },
  methods: {
    setActiveTab(tab) {
      this.activeTab = tab;
    },
  },
  mounted() {
    this.activeTab = this.tabs[0];
  },
}
</script>

<template>
  <div class="profile-content-info-wrap">
    <div class="profile-content-info">
      <div class="profile-content-tabs">
        <base-tab v-for="tab in tabs"
                  :key="tab.code"
                  :label="tab.label"
                  :active="tab.code === activeTab.code"
                  @click="setActiveTab(tab)"
        ></base-tab>
      </div>
      <div class="profile-content-main">
        <div v-show="activeTab.code === 'EVENTS'">
          <profile-critical-events v-show="isOwnProfile" :entity-id="orgId" :entity-type="CreatorType.ORGANIZATION"/>
        </div>
        <div v-if="activeTab.code === 'NEWS'">
          <org-profile-news-list/>
        </div>
        <div v-if="activeTab.code === 'OPINIONS'">
          <org-profile-opinions-list/>
        </div>
        <div v-if="activeTab.code === 'PROPOSALS'">
          <org-profile-proposals-list/>
        </div>
        <div v-show="activeTab.code === 'ADMINS'">
          <org-profile-manage-admins v-show="isOwnProfile" :org-id="orgId"/>
        </div>
      </div>
    </div>
</div>
</template>

<style lang="scss">
.profile-content-info {
  .profile-content-tabs {
    display: flex;
    height: 36px;
    border-bottom: 1px solid #ddd;
    box-shadow: 0 1px 1px #ddd;
    white-space: nowrap;
    background: #fff;
    .base-tab {
      width: auto;
      padding: 0 15px;
    }
  }
}
</style>